import AccessRightsUserSalesPage from "../../../component/users/sales/AccessRightsUserSales"

 
 
function AccessRightsUserSales() {
  return (
    <div className="page-body"><AccessRightsUserSalesPage/></div>
  )
}

export default AccessRightsUserSales